import { render, staticRenderFns } from "./secure_avantage.vue?vue&type=template&id=8b0233d4&"
import script from "./secure_avantage.vue?vue&type=script&lang=js&"
export * from "./secure_avantage.vue?vue&type=script&lang=js&"
import style0 from "./secure_avantage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports